import { render } from "./FkDetail.vue?vue&type=template&id=da661e70"
import script from "./FkDetail.vue?vue&type=script&lang=js"
export * from "./FkDetail.vue?vue&type=script&lang=js"

import "./FkDetail.vue?vue&type=style&index=0&id=da661e70&lang=less"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__